import Button from 'components/Basic/Button';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toggleOrientationModalState } from 'store/slices/ChangeOrientationModalSlice';
import { clearAction, registerActionHandler } from '../../ToolRegistry';
import { TOOL_ACTION } from 'store/selectors/toolSelector';

type Props = {
  isMobileView: boolean;
  disableChangeOrientationBtn: boolean;
  changeOrientationQueryRunning: boolean;
};
export default function ChangeOrientationButton ({
	isMobileView,
	disableChangeOrientationBtn,
	changeOrientationQueryRunning,
}: Props) {
	const dispatch = useDispatch();

	const handleClick = useCallback(() => {
		if (!disableChangeOrientationBtn) {
			dispatch(toggleOrientationModalState({ open: true, isLoading: false }));
		}
	}, [dispatch, disableChangeOrientationBtn]);

	useEffect(() => {
		registerActionHandler(TOOL_ACTION.CHANGE_ORIENTATION, handleClick);
		return () => {
			clearAction(TOOL_ACTION.CHANGE_ORIENTATION);
		};
	}, [handleClick]);

	return (
		<Button
			id="change-orientation"
			className="btn-tools"
			style={{ background: 'var(--defaultBgColor)' }}
			onClick={handleClick}
			disabled={disableChangeOrientationBtn}
			showLoader={changeOrientationQueryRunning}
			tooltipContent="Change Orientation"
		>
			<svg
				width={isMobileView ? '21' : '22'}
				height={isMobileView ? '2' : '22'}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M23 9.97489C23 5.92469 19.7407 2.24268 15.0329 2.24268L17.2058 4.82008M1 14.3933C1 18.4435 4.25926 22.1255 8.96708 22.1255L6.79424 19.5481M8.2428 1L22.6379 15.636L15.3951 23L1 8.36402L8.2428 1Z"
					stroke="var(--defaultIconColor)"
					strokeWidth="1.69284"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</Button>
	);
}
